import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'

import globalFn from './globalFn'
import Http from './http'

export const global = {
LoadingPlugin,
AlertPlugin,
ToastPlugin,
DatetimePlugin,
ConfirmPlugin,
globalFn,
Http,
WechatPlugin
};



// WEBPACK FOOTER //
// ./src/plugins/index.js